import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8cq2ziwn: FaireBrandEntity = {
  token: "b_8cq2ziwn",
  type: "brand",
  name: "Jack N' Jill Kids & NFco",
  avatarUrl:
    "https://cdn.faire.com/fastly/788230b4c0d6927506bd759449f8ad07ba31b7ffedf5ef5c533939348f7a243c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fb346520427c67edb536183c5bda8b3be126dfde099994443871f6d22cadcecb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/788230b4c0d6927506bd759449f8ad07ba31b7ffedf5ef5c533939348f7a243c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fb346520427c67edb536183c5bda8b3be126dfde099994443871f6d22cadcecb.png",
  location: "Carson, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Jack N' Jill Kids is a natural toothpaste for babies, toddlers and children that is safe to swallow. It was first made in Melbourne, Australia in 1949 and it has been our family business for more than 20 years. It continues to be made in Australia and we are excited that Jack N' Jill Kids is now available in more than 50 countries.\n\nA few years ago we had our first child and immediately joined many parents the world over who are concerned about current environmental issues and the direct effects they have on our children. We started to question everything he came into contact with, not wanting to expose him to unnecessary additives and chemicals. We felt frustrated about the lack of choice in early childhood oral hygiene and personal care. With a background in pharmacy, we set out to formulate the absolute safest products for our kids and yours. In the process, we also made safe, fun and eco friendly!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:57.286Z",
    importedBy: "entity-db-cli",
  },
};
